import { Container } from "components/layout/Container";
import { ContentsTable } from "components/layout/ContentsTable";
import { FAQList, FAQListProps } from "components/pages/faq/FAQList";
import { NotFound } from "components/shared/NotFound";
import styles from "./SectionContent.module.scss";
import { SideLink } from "./SideLink";
import { FAQPageType } from "@/components/pages/faq/FAQPage";

const sideLinks = [
  {
    title: "Contact support",
    href: "/contacts",
    icon: "telephone-receiver" as const,
  },
  {
    title: "How we work",
    href: "/how-it-works",
    icon: "gear" as const,
  },
];

type SectionContentProps = {
  faq: FAQListProps[];
  isNotFound?: boolean;
  query: string;
  type: FAQPageType;
};

export const SectionContent = ({ faq, isNotFound, query, type }: SectionContentProps) => {
  return (
    <Container className={styles.container}>
      <div className={styles.inner}>
        <div className={styles.contentsTableWrap}>
          <ContentsTable
            items={faq.map((item, index) => ({
              ...item,
              heading: `${index + 1}. ${item.heading}`,
            }))}
          />
          {type === "commercial" && (
            <div className={styles.sideButtons}>
              {sideLinks.map((sideLink) => (
                <SideLink key={sideLink.icon} {...sideLink} />
              ))}
            </div>
          )}
        </div>
        <div className={styles.content}>
          {isNotFound && <NotFound className={styles.notFound} query={query} />}
          {type === "commercial" && (
            <div className={styles.contentButtons}>
              {sideLinks.map((sideLink) => (
                <SideLink key={sideLink.icon} {...sideLink} />
              ))}
            </div>
          )}
          <main className={styles.main}>
            {faq.map((item) => (
              <FAQList className={styles.list} key={item.id} {...item} />
            ))}
          </main>
        </div>
      </div>
    </Container>
  );
};
